import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Alert, AlertType } from './alert';
import { AbAlert } from 'app/abstract/full-pages/customs/alert/alert.abstract';

@Injectable({ providedIn: 'root' })
export class AlertService extends AbAlert implements OnDestroy {
  public subject = new Subject<Alert>();
  public keepAfterRouteChange = false;

  private readonly destroy$ = new Subject();

  constructor(private router: Router) {
    super();
    // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
    router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterRouteChange) {
          // only keep for a single route change
          this.keepAfterRouteChange = false;
        } else {
          // clear alert messages
          this.clear();
        }
      }
    });
  }

  getAlert(): Observable<any> {
    return this.subject.asObservable();
  }

  success(message: string, keepAfterRouteChange = false) {
    this.alert(AlertType.Success, message, keepAfterRouteChange);
  }

  error(message: string, keepAfterRouteChange = false) {
    this.alert(AlertType.Error, message, keepAfterRouteChange);
  }

  info(message: string, keepAfterRouteChange = false) {
    this.alert(AlertType.Info, message, keepAfterRouteChange);
  }

  warn(message: string, keepAfterRouteChange = false) {
    this.alert(AlertType.Warning, message, keepAfterRouteChange);
  }

  showSuccessMessage(): void {
    this.success('Salvo com sucesso.');
  }

  showErrorMessage(): void {
    this.error('Erro ao salvar.');
  }

  showDeleteSuccessMessage(): void {
    this.success('Excluído com sucesso.');
  }

  handlerError(err: any): void {
    if (err?.error?.status == 500) return this.error(err.error?.message);

    return this.showErrorMessage();
  }

  alert(type: AlertType, message: string, keepAfterRouteChange = false) {
    this.clear();
    this.keepAfterRouteChange = keepAfterRouteChange;
    this.subject.next(<Alert>{ type: type, message: message });
  }

  clear() {
    // clear alerts
    this.subject.next(undefined);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
